import styles from './MapStyles.module.css';
import { mapStyles } from '../../../constants/variables';
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { useState, useEffect } from 'react';

export const MapStyles = ({
    onToggleStyleButton,
    activeStyle,
}) => {
    const [ anchorEl, setAnchorEl ] = useState(null);
    const [ isMobileMenu, setIsMobileMenu ] = useState(window.innerWidth <= 850);

    useEffect(() => {
        const handleResize = () => {
            setIsMobileMenu(window.innerWidth <= 850);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);
    const handleMenuOpen = event => {
        setAnchorEl(event.currentTarget);
    };
    const handleMenuClose = () => {
        setAnchorEl(null);
    };
    const handleStyleSelect = key => {
        onToggleStyleButton(key);
        handleMenuClose();
    };

    if (isMobileMenu) {
        const styleKeys = Object.keys(mapStyles);
        const currentStyleLabel = activeStyle.charAt(0).toUpperCase() + activeStyle.slice(1);

        return (
            <>
                <Button
                    className={styles.mobileStyleButton}
                    onClick={handleMenuOpen}
                    size='small'
                    variant='text'
                    color='default'
                >
                    ▼ {currentStyleLabel}
                </Button>
                <Menu
                    anchorEl={anchorEl}
                    keepMounted
                    open={Boolean(anchorEl)}
                    onClose={handleMenuClose}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                    }}
                >
                    {styleKeys.map(key => (
                        <MenuItem
                            key={key}
                            onClick={() => handleStyleSelect(key)}
                            selected={activeStyle === key}
                        >
                            {key.charAt(0).toUpperCase() + key.slice(1)}
                        </MenuItem>
                    ))}
                </Menu>
            </>
        );
    }

    return (
        <ButtonGroup
            className={styles.stylesWrapper}
            variant='contained'
            size='small'
        >
            {
                Object.keys(mapStyles).map(key => (
                    <Button
                        key={key}
                        onClick={() => onToggleStyleButton(key)}
                        color={activeStyle === key ? 'primary' : 'default'}
                    >
                        {key}
                    </Button>
                ))
            }

        </ButtonGroup>
    );
};

